<template>
  <v-dialog
    :model-value="show"
    @update:model-value="$emit('close')"
    :width="'500px'"
    max-width="100%"
    :fullscreen="$vuetify.display.xs"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Comment</h5>
        <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="comment-txt">
          <div v-for="(line, i) in comment.split('\n')" :key="line" :data-cy="`comment-line-${i}`">
            {{ line }}
          </div>
        </div>
      </div>
    </div>
    <div class="fill-bottom"></div>
  </v-dialog>
</template>

<script lang="ts" setup>
defineProps<{
  show: boolean;
  comment: string;
}>();

defineEmits<{
  (e: 'close', ...args: any[]): void
}>();
</script>
<style>
.comment-txt {
  padding: 5px;
  background-color: white;
  border: 1px solid #cccccc;
  border-radius: 4px;
}
.fill-bottom {
  height: 50vh;
  width: 100%;
}
</style>
